import { render, staticRenderFns } from "./CodeBlockComponent.vue?vue&type=template&id=251adde8"
import script from "./CodeBlockComponent.vue?vue&type=script&lang=js"
export * from "./CodeBlockComponent.vue?vue&type=script&lang=js"
import style0 from "./CodeBlockComponent.vue?vue&type=style&index=0&id=251adde8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports